import React from 'react'
import { useIntl } from 'react-intl'
import { useConfig } from 'msp-integrations'
import { SpinnerProps } from './Spinner.types'
import { twMerge } from 'tailwind-merge'

const SpinnerSize = {
  xs: 'w-3 h-3 after:w-3 after:h-3',
  sm: 'w-4 h-4 after:w-4 after:h-4',
  md: 'w-6 h-6 after:w-6 after:h-6',
  lg: 'w-8 h-8 after:w-8 after:h-8',
  xl: 'w-12 h-12 after:w-12 after:h-12'
}

const SpinnerColorScheme = {
  light:
    'border-t-gray94 border-r-gray94 border-l-grayRegular border-b-grayRegular border-solid',
  dark: 'border-t-black border-r-black border-l-gray94 border-b-gray94 border-solid'
}

const Spinner = ({
  colorScheme = 'dark',
  fullScreen = false,
  label,
  size = 'md',
  className = '',
  forbidBackgroundClick = false
}: SpinnerProps) => {
  const { formatMessage } = useIntl()
  const {
    theme: {
      mspComponents: { spinner }
    }
  } = useConfig()
  return (
    <div
      className={twMerge(
        `${
          fullScreen
            ? `${forbidBackgroundClick || 'pointer-events-none'} fixed ${
                spinner.position
              } z-[9999] flex h-screen w-full items-center justify-center ${
                colorScheme === 'dark'
                  ? spinner.fullscreenContainer.dark
                  : spinner.fullscreenContainer.light
              }`
            : ''
        }`
      )}
    >
      {fullScreen ? (
        <>
          {spinner?.content}
          {label && (
            <div
              className={`absolute translate-y-20 px-4 text-center ${
                colorScheme === 'dark'
                  ? spinner.label.dark
                  : spinner.label.light
              }`}
            >
              {label}
            </div>
          )}
        </>
      ) : (
        <div>
          <div
            className={`text-10 border-box animate-spinner relative m-auto duration-500 ${
              fullScreen ? SpinnerSize.xl : SpinnerSize[size]
            } ${
              SpinnerColorScheme[colorScheme]
            } rounded-full border-4 ${className}`}
          />
          <span className='absolute -indent-[9999em]'>
            {label ||
              formatMessage({ id: 'loading', defaultMessage: 'Loading...' })}
          </span>
        </div>
      )}
    </div>
  )
}

export default Spinner
